import { StoreOrder } from "@/store/payment"

export function formatCurrency(unit?: string | number) {
    if (!unit) return "0"
    let ans: string = "",
        current: number = 0,
        _unit: string[] = unit.toString().split(".")

    for (let i = _unit[0].length - 1; i >= 0; --i) {
        ans = _unit[0][i] + ans
        current++
        if (current === 3 && i) {
            current = 0
            ans = "," + ans
        }
    }

    return ans + (_unit[1] ? "." + _unit[1].slice(0, 2) : "")
}

export const strDealwith = (str: React.Key = "", start = 4, end = -4) => {
    let result = ["string", "number"].includes(typeof str) ? str.toString() : ""
    try {
        result = result.slice(0, start) + Array(result.slice(start, end).length).fill("*").join("") + result.slice(end)
    }
    catch (err) {
        console.log(err)
    } finally {
        return result
    }
}

// export function formatEther(num: string | number | undefined) {
//     return calc.div(num ?? 0, 10e17)
// }

export const addZero = (number: number) => {
    return number.toString().padStart(2, '0')
}

export const spaceReplace = (str: string) => str.replace(/\s+|\s+/g, " ")

export function toFixed(target: string, fractionDigits: number = 4) {
    let result = target
    if (result.includes(".")) {
        let ans = result.slice(0, result.indexOf("."))
        return ans + "." + result.slice(result.indexOf(".") + 1).slice(0, fractionDigits)
    }
    return result
}

export const checkIsMobile = () => {
    return /(iPhone|iPad|iPod|Opera Mini|Android.*Mobile|NetFront|PSP|BlackBerry|Windows Phone)/ig.test(window.navigator.userAgent)
}

export function desensitizeString(
    string: string,
    desensitizeNumber = 7,
    desensitizeRule = "****",
    endNumber?: number,
) {
    const reg = new RegExp(
        `^(.{${desensitizeNumber}})(.*)(.{${endNumber || desensitizeNumber}})$`,
    );
    return string.replace(reg, `$1${desensitizeRule}$3`);
}

export type ChainDetailInfo = {
    chainId: string
    chainName: string
    nativeCurrency: {
        name: string
        symbol: string
        decimals: number
    }
    rpcUrls: string[]
    blockExplorerUrls: string[]
}

export const getChainDetail = (order: StoreOrder): ChainDetailInfo => {
    const { chain_id, chain, chain_info } = order
    const { token, decimal, browser_url, rpc } = chain_info

    return {
        chainId: `0x${(chain_id >>> 0).toString(16)}`,
        chainName: chain,
        nativeCurrency: {
            name: token,
            symbol: token,
            decimals: decimal
        },
        rpcUrls: [rpc],
        blockExplorerUrls: [browser_url]
    }
}
